export default {
  charge:   2,
  donation: 1,
  guest:    4,
  info:     0,
  success:  3
};
